module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0003-1f77f35a99b4ec4350a6d8dafaeb2e4f.jpg";